<app-filter-panel [fields]="fieldsConfig" [quickSearchFilter]="chips.code"
    quickSearchPlaceholder="Código" (search)="search()"></app-filter-panel>

<!--
<div class="flex gap-2 cola-4">
    <span class="input-field p-input-icon-right">
        <input pInputText placeholder="Código" [(ngModel)]="filters.code.value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.code.value" class="pi pi-times cursor-pointer"
            (click)="filters.code.value = null; search()"></i>
    </span>
    <span class="input-field p-input-icon-right">
        <input pInputText placeholder="Expediente" [(ngModel)]="filters.caseNumber.value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.caseNumber.value" class="pi pi-times cursor-pointer"
            (click)="filters.caseNumber.value = null; search()"></i>
    </span>
    <span class="input-field p-input-icon-right">
        <input pInputText placeholder="Nº servicio" [(ngModel)]="filters.caseNotificationNumber.filter.value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.caseNotificationNumber.filter.value" class="pi pi-times cursor-pointer"
            (click)="filters.caseNotificationNumber.filter.value = null; search()"></i>
    </span>
    <div class="input-field">
        <p-dropdown [placeholder]="thirdPartyName" [options]="thirdParties" optionLabel="name" optionValue="id" [filter]="true" (onFilter)="loadThirdParties($event)"
            [(ngModel)]="filters.thirdPartyId.value" (onChange)="search()" showClear />
    </div>
    <div class="input-field">
        <p-dropdown placeholder="Estado" [options]="transactionStates" optionLabel="name" optionValue="id" [filter]="true"
            [(ngModel)]="filters.transactionStateId.value" (onChange)="search()" showClear /> 
    </div>
    <div class="input-field" *ngIf="transactionType?.code != 'worker_invoice_request'">
        <p-dropdown placeholder="Sociedad" [options]="business" optionLabel="name" optionValue="id" [filter]="true"
            [(ngModel)]="filters.businessId.value" (onChange)="search()" showClear /> 
    </div>
    <div class="input-field">        
        <p-calendar [firstDayOfWeek]="1" [(ngModel)]="filtersDate.dateFrom" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
            [yearNavigator]="true" dateFormat="dd/mm/yy" appendTo="body" (onSelect)="search()"
            (onClear)="search()" placeholder="Desde"></p-calendar>
    </div>
    <div class="input-field">        
        <p-calendar [firstDayOfWeek]="1" [(ngModel)]="filtersDate.dateTo" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
            [yearNavigator]="true" dateFormat="dd/mm/yy" appendTo="body" (onSelect)="search()"
            (onClear)="search()" placeholder="Hasta"></p-calendar>
    </div>    
    <div class="input-field">        
        <p-calendar [firstDayOfWeek]="1" [(ngModel)]="filtersDate.paymentDuedateFrom" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
            [yearNavigator]="true" dateFormat="dd/mm/yy" appendTo="body" (onSelect)="search()"
            (onClear)="search()" placeholder="Fecha vencimiento desde"></p-calendar>
    </div>
    <div class="input-field">        
        <p-calendar [firstDayOfWeek]="1" [(ngModel)]="filtersDate.paymentDuedateTo" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
            [yearNavigator]="true" dateFormat="dd/mm/yy" appendTo="body" (onSelect)="search()"
            (onClear)="search()" placeholder="Fecha vencimiento hasta"></p-calendar>
    </div>    
    <div class="input-field">
        <label for="netSuiteId">No enlazados</label>
        <p-checkbox [(ngModel)]="filters.netSuiteId.allowNull" [binary]="true" id="netSuiteId"
            (onChange)="search()" ></p-checkbox>
    </div>
     <div class="input-field" *ngIf="type!= 'incoming_invoice'">          
        <p-dropdown placeholder="Tramitador" [options]="processors" optionLabel="name" optionValue="id" [filter]="true"
            [(ngModel)]="filters.originalProcessorId.value" (onChange)="search()" showClear appendTo="body" />
        </div>        
    <div class="input-field flex">
        <button pButton  label="Buscar" icon="pi pi-search" (click)="search()"></button>
        <button pButton ngClass="ml-2" label="Limpiar" icon="pi pi-eraser" (click)="clearFilters()" severity="secondary" ></button>
    </div>
</div>
-->

<p-table [styleClass]="selectionCollapsed ? '' : 'selection-expanded'" #grid [value]="transactions" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading"
    [paginator]="true" [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
    [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body"
    [selection]="selectedRowsIds" (selectionChange)="onSelectionChange($event)" [selectionPageOnly]="true" dataKey="id"
    (onHeaderCheckboxToggle)="onHeaderCheckboxToggle($event)" [rowSelectable]="isRowSelectable"
    [frozenValue]="allowRowSelection && selectedRowsIds.length ? selectedRowsIds : undefined">
    <ng-template pTemplate="header" let-columns>
        <tr>                        
            <th style="width: 4rem" *ngIf="allowRowSelection"><p-tableHeaderCheckbox /></th>
            <th pSortableColumn="code">Código <p-sortIcon field="code"></p-sortIcon></th>
            <th pSortableColumn="date">Fecha <p-sortIcon field="date"></p-sortIcon></th>   
            <!--<th pSortableColumn="date">Fecha Vto <p-sortIcon field="paymentDuedate"></p-sortIcon></th>-->   
            <th pSortableColumn="transactionState.name">Estado <p-sortIcon field="transactionState.name"></p-sortIcon></th>   
            <th *ngIf="transactionType?.code == 'company_outgoing_invoice' || transactionType?.code == 'outgoing_invoice_worker' || transactionType?.code == 'incoming_invoice' || transactionType?.code == 'outgoing_invoice' " pSortableColumn="paymentDuedate">Fecha vencimiento <p-sortIcon field="paymentDuedate"></p-sortIcon></th>    
            <th *ngIf="transactionType?.code == 'company_outgoing_delivery_note'" pSortableColumn="transactionState.name">Factura <p-sortIcon field="transactionState.name"></p-sortIcon></th>   
            <th pSortableColumn="thirdPartyId" *ngIf="transactionType?.thirdPartyType != null">{{transactionType?.thirdPartyType == "Client"?"Cliente":
                transactionType?.thirdPartyType == "Company"?"Compañía":
                transactionType?.thirdPartyType == "Provider"?"Proveedor":"Operario"}} <p-sortIcon field="thirdPartyId"></p-sortIcon></th>  
            <th *ngIf="transactionType?.code != 'worker_invoice_request'" pSortableColumn="business.name">Sociedad <p-sortIcon field="business.name"></p-sortIcon></th>    
            <th pSortableColumn="case.name" *ngIf="transactionType?.enableCase">Expediente <p-sortIcon field="transactionState.name"></p-sortIcon></th>    
            <th pSortableColumn="case.name" *ngIf="transactionType?.enableCaseServiceNotificationNumber">Nº servicio <p-sortIcon field="transactionState.name"></p-sortIcon></th>                
            <th *ngIf="transactionType?.code == 'company_outgoing_invoice'" pSortableColumn="transactionState.name">Abono <p-sortIcon field="transactionState.name"></p-sortIcon></th>   
            <th pSortableColumn="subtotal" *ngIf="transactionType?.enablePrice">Neto <p-sortIcon field="subtotal"></p-sortIcon></th>
            <th pSortableColumn="taxAmount" *ngIf="transactionType?.enablePrice">Iva <p-sortIcon field="taxAmount"></p-sortIcon></th>
            <th pSortableColumn="total" *ngIf="transactionType?.enablePrice">Total <p-sortIcon field="total"></p-sortIcon></th>   
            <th [attr.width]="transactionType?.code == 'worker_invoice_request' ? '350' : '100'"></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-transaction let-columns="columns">
        <tr (dblclick)="edit(transaction)" [ngClass]="{'opacity-40': allowRowSelection && !transaction.transactionState?.isFinal && !isSelectable(transaction)}">
            <td *ngIf="allowRowSelection">
                <span *ngIf="!transaction.transactionState?.isFinal" pTooltip="No compatible con la selección: distinta compañía o sociedad" [tooltipDisabled]="isSelectable(transaction)" tooltipPosition="right">
                    <p-tableCheckbox [value]="transaction" [disabled]="!isSelectable(transaction)"/>
                </span>
            </td>
            <td>
                <i class="pi pi-link" pTooltip="Enlace con NetSuite realizado" *ngIf="transaction.netSuiteId!=null"></i> 
                <i class="pi pi-times-circle text-red-500" pTooltip="{{transaction.netSuiteError}}" *ngIf="transaction.netSuiteId==null && transaction.netSuiteError!=null"></i> 
                {{transaction.code}}<br>
                <small>{{transaction.originalProcessor?.name}}</small>
                <!--<small *ngIf="!transaction.originalProcessorId">Exp: {{transaction.case?.processor?.name}}</small>-->
                <span *ngIf="transaction.isAdvancePayment" class="p-tag p-tag-info">ANTICIPO</span>
            </td>
            <td>{{transaction.date | date:'dd/MM/yy'}}</td>
            <!--<td>{{transaction.paymentDuedate | date:'dd/MM/yy'}}</td>-->
            <td>
                <span class="p-tag" [style.backgroundColor]="transaction.transactionState?.backgroundColor" [style.foregroundColor]="transaction.transactionState?.foregroundColor" [pTooltip]="getStateTooltip(transaction)">
                    <span class="p-tag-label">{{transaction.transactionState?.name}}</span>
                </span>
            </td>            
            <td *ngIf="transactionType?.code == 'company_outgoing_invoice' || transactionType?.code == 'outgoing_invoice_worker' || transactionType?.code == 'incoming_invoice' || transactionType?.code == 'outgoing_invoice' ">
                <span *ngIf="transaction.paymentDuedate != null &&(transaction.paymentDuedate < today || transaction.paymentDuedate <= soon)"
                    class="p-tag" 
                    [ngStyle]="{
                        'background-color': 
                        transaction.paymentDuedate < today ? '#f87171' : 
                        transaction.paymentDuedate <= soon ? '#facc15' : 
                            '',
                    }">
                {{ transaction.paymentDuedate | date:'dd/MM/yy' }}
                </span>
                <span *ngIf="transaction.paymentDuedate > soon">
                    {{ transaction.paymentDuedate | date:'dd/MM/yy' }}
                </span>
            </td>            
            <td *ngIf="transactionType?.code == 'company_outgoing_delivery_note'">
                <a [routerLink]="['/transactions/company_outgoing_invoice', transaction.relatedTransaction?.id]">{{transaction.relatedTransaction?.code}}</a><br>
                <small>{{transaction.relatedTransaction?.date | date:'dd/MM/yy'}}</small>
            </td>
            <td>
                <div *ngIf="transactionType?.thirdPartyType != null">
                    <app-deleted-label [resource]="transaction.thirdParty"></app-deleted-label><br>
                        <small *ngIf="(transactionType?.code == 'outgoing_invoice' || transactionType?.code == 'incoming_invoice') && transaction.thirdParty?.vatNumber">
                            {{transaction.thirdParty?.vatNumber}}
                        </small>
                        <small *ngIf="(transactionType?.code == 'outgoing_invoice' || transactionType?.code == 'incoming_invoice') && !transaction.thirdParty?.vatNumber" style="color: red">(SIN DNI/NIF)</small>
                </div>
            </td>
            <td *ngIf="transactionType?.code != 'worker_invoice_request'">{{transaction.business?.name}}</td>            
            <td *ngIf="transactionType?.enableCase">
                <div *ngIf="transaction.case">
                    <a [routerLink]="['/cases', transaction.case.id]">{{transaction.case?.caseNumber}}</a><br>
                    <small>{{transaction.case?.contract?.code}}</small>
                </div>
            </td>
            <td *ngIf="transactionType?.enableCaseServiceNotificationNumber">
                <div *ngIf="transaction.caseService">
                    <a [routerLink]="['/cases', transaction.case.id]">{{transaction.caseService?.caseNotificationNumber.code}}</a><br>
                    <small>{{transaction.caseService?.contract?.code}}</small>
                </div>
                <div *ngIf="transaction.caseNotificationNumber">
                    {{transaction.caseNotificationNumber.code}}
                </div>
            </td>  
            <td *ngIf="transactionType?.code == 'company_outgoing_invoice'">
                <div *ngIf="transaction.relatedTransaction?.isReturn">
                    <a [routerLink]="['/transactions/company_outgoing_invoice', transaction.relatedTransaction?.id]">{{transaction.relatedTransaction?.code}}</a><br>
                    <small>{{transaction.relatedTransaction?.date | date:'dd/MM/yy'}}</small>
                </div>
            </td>
            
            <td *ngIf="transactionType?.enablePrice">{{transaction.isReturn?'-':''}}{{transaction.subtotal | currency:'EUR'}}</td>            
            <td *ngIf="transactionType?.enableTax">{{transaction.isReturn?'-':''}}{{transaction.taxAmount | currency:'EUR'}}</td>
            <td *ngIf="transactionType?.enablePrice">{{transaction.isReturn?'-':''}}{{transaction.total | currency:'EUR'}}</td>
            <td>
                <div class="flex gap-2 justify-content-end">
                    <p-button *ngIf="allowWrite && transactionType?.code == 'worker_invoice_request' && transaction.transactionState.code == 'pending'" (click)="generateRequest(transaction)" [rounded]="true" label="Generar factura"
                        ><i class="pi pi-check"></i></p-button>
                    <p-button *ngIf="allowWrite && transactionType?.code == 'worker_invoice_request' && transaction.transactionState.code == 'pending'" (click)="rejectRequest(transaction)" [rounded]="true" label="Rechazar"
                    ><i class="pi pi-times"></i></p-button>
                    <p-button *ngIf="allowWrite && transactionType?.code == 'company_outgoing_invoice' && !transaction.relatedTransactionId && !transaction.isReturn && transaction.transactionState?.code == 'in_review'" (click)="generateReview(transaction)" [rounded]="true" label="Revisión"
                        ><i class="pi pi-undo"></i></p-button>
                    <p-button *ngIf="allowWrite && loginService.hasPermission('COMPANY_OUTGOING_INVOICE.RETURN_GENERATE') && (transactionType?.code == 'company_outgoing_invoice' || transactionType?.code == 'outgoing_invoice' || transactionType?.code == 'incoming_invoice') && !transaction.relatedTransactionId && !transaction.isReturn && transaction.transactionState?.code != 'in_review'" 
                            (click)="generatePayment(transaction)" [rounded]="true" label="Abono"><i class="pi pi-undo"></i></p-button>
                    <p-button *ngIf="allowWrite && loginService.hasPermission('INCOMING_INVOICE.RETURN_GENERATE') && (transactionType?.code == 'incoming_invoice') && !transaction.relatedTransactionId && !transaction.isReturn && transaction.transactionState?.code != 'in_review'" 
                            (click)="generatePayment(transaction)" [rounded]="true" label="Abono"><i class="pi pi-undo"></i></p-button>
                    <p-button *ngIf="allowWrite && transactionType?.document_type" (click)="exportTransaction(transactionType?.code, transaction.id, transaction.case?.contractId, transaction.case?.companyId)" [rounded]="true"><i class="pi pi-print"></i></p-button>
                    <p-button *ngIf="allowDelete && transaction.netSuiteId == null" (click)="delete(transaction)" [rounded]="true" [text]="false"
                        severity="danger"><i class="pi pi-trash"></i></p-button>
                    <p-button *ngIf="allowWrite" (click)="edit(transaction)" [rounded]="true" [text]="false"><i
                            class="pi pi-pencil"></i></p-button>
                </div>
            </td>
        </tr>
    </ng-template>
    <!-- albaranes seleccionados, fijados arriba aunque se cambie de página o de filtro -->
    <ng-template pTemplate="frozenbody" let-transaction>
        <tr class="p-highlight" *ngIf="!selectionCollapsed">
            <td><p-tableCheckbox [value]="transaction" /></td>
            <td>
                {{transaction.code}}<br>
                <small>{{transaction.originalProcessor?.name}}</small>
            </td>
            <td>{{transaction.date | date:'dd/MM/yy'}}</td>
            <td>
                <span class="p-tag" [style.backgroundColor]="transaction.transactionState?.backgroundColor" [style.foregroundColor]="transaction.transactionState?.foregroundColor">
                    <span class="p-tag-label">{{transaction.transactionState?.name}}</span>
                </span>
            </td>
            <td></td>
            <td>{{transaction.thirdParty?.name}}</td>
            <td>{{transaction.business?.name}}</td>
            <td *ngIf="transactionType?.enableCase">
                <div *ngIf="transaction.case">
                    {{transaction.case?.caseNumber}}<br>
                    <small>{{transaction.case?.contract?.code}}</small>
                </div>
            </td>
            <td *ngIf="transactionType?.enableCaseServiceNotificationNumber">
                {{transaction.caseService?.caseNotificationNumber?.code ?? transaction.caseNotificationNumber?.code}}
            </td>
            <td *ngIf="transactionType?.enablePrice">{{transaction.subtotal | currency:'EUR'}}</td>
            <td *ngIf="transactionType?.enableTax">{{transaction.taxAmount | currency:'EUR'}}</td>
            <td *ngIf="transactionType?.enablePrice">{{transaction.total | currency:'EUR'}}</td>
            <td>
                <div class="flex justify-content-end">
                    <p-button icon="pi pi-times" [rounded]="true" [text]="true" severity="secondary" pTooltip="Quitar de la selección" tooltipPosition="left"
                        (click)="unselectTransaction(transaction)" />
                </div>
            </td>
        </tr>
        <!-- rowIndex suma el desplazamiento de la página, así que el último se detecta por referencia -->
        <ng-container *ngIf="transaction === selectedRowsIds[selectedRowsIds.length - 1]">
            <tr class="p-highlight font-bold">
                <td [attr.colspan]="7">Seleccionados ({{selectedRowsIds.length}})</td>
                <td *ngIf="transactionType?.enableCase"></td>
                <td *ngIf="transactionType?.enableCaseServiceNotificationNumber"></td>
                <td *ngIf="transactionType?.enablePrice">{{sumSelected('subtotal') | currency:'EUR'}}</td>
                <td *ngIf="transactionType?.enableTax">{{sumSelected('taxAmount') | currency:'EUR'}}</td>
                <td *ngIf="transactionType?.enablePrice">{{sumSelected('total') | currency:'EUR'}}</td>
                <td>
                    <div class="flex gap-2 justify-content-end">
                        <p-button [icon]="selectionCollapsed ? 'pi pi-chevron-down' : 'pi pi-chevron-up'" [rounded]="true" [text]="true" severity="secondary"
                            [pTooltip]="selectionCollapsed ? 'Ver seleccionados' : 'Ocultar seleccionados'" tooltipPosition="left" (click)="toggleSelectionCollapsed()" />
                        <p-button icon="pi pi-eraser" [rounded]="true" [text]="true" severity="secondary" pTooltip="Limpiar selección" tooltipPosition="left"
                            (click)="clearSelection()" />
                    </div>
                </td>
            </tr>
            <tr *ngIf="!selectionCollapsed">
                <td colspan="14" class="text-sm font-semibold text-500 py-1">RESULTADOS DE LA BÚSQUEDA</td>
            </tr>
        </ng-container>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="allowRowSelection?14:12" class="text-center">        
             No se ha encontrado transacciones
          </td>
        </tr>
      </ng-template>
</p-table>

<p-dialog header="Abono" [(visible)]="displayPaymentModal" [modal]="true" [closable]="false"
    [style]="{width: '800px'}">
    <div class="grid">
        <div class="col-6 input-field">
            <label for="date">Fecha</label>
            <p-calendar [firstDayOfWeek]="1" id="date" [(ngModel)]="payment.date" [showIcon]="true" [showButtonBar]="true"
                [monthNavigator]="true" [yearNavigator]="true" dateFormat="dd/mm/yy"
                appendTo="body"></p-calendar>
        </div>
        <div class="col-6 input-field" *ngIf="transactionSelected.transactionSerieId==null">
            <label for="date">Nº de abono</label>
            <input [(ngModel)]="payment.code" pInputText>
        </div>
        <div class="col-6 input-field">
            <label for="code">Tipo de abono</label>
            <p-dropdown [(ngModel)]="payment.type" [options]="typesPayment"
                optionLabel="name" optionValue="id" appendTo="body" filterBy="name"
                placeholder="Seleccione opción"  d-form-field-error></p-dropdown>                            
        </div> 
        <div class="col-6 input-field">
            <span *ngIf="transactionsLinesToPayment.length>0">
                Se van a abonar un total de {{selectedTransactionLinesToPayment.length}} trabajos
            </span>
        </div>
    </div>

    <div class="grid" *ngIf="transactionsLinesToPayment.length>0&&payment.type!='total'">
        <div class="col-12">
            <p-table [value]="transactionsLinesToPayment" [selection]="selectedTransactionLinesToPayment"
                (selectionChange)="onTransactionLinesToPaymentSelectionChange($event)" dataKey="id"
                styleClass="p-datatable-sm payment-lines-table">
                <ng-template pTemplate="header">
                    <tr>
                        <th width="30"><p-tableHeaderCheckbox *ngIf="transactionsLinesToPayment.length>0" /></th>
                        <th>Expediente</th>
                        <th>Especialidad / Baremo / Descripción</th>
                        <th width="60">Cant.</th>
                        <th width="80">P. unidad</th>
                        <th width="80">Subtotal</th>
                        <th width="70">Impuestos</th>
                        <th width="80">Importe</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-line>
                    <tr>
                        <td>
                            <p-tableCheckbox [value]="line"></p-tableCheckbox>
                        </td>
                        <td>{{line.caseService?.case?.caseNumber}}</td>
                        <td>
                            <div>{{line.caseService?.capability?.name}}</div>
                            <div>{{line.rateLineCode}} - {{line.rateLineDescription}}</div>
                            <div><small>{{line.description}}</small></div>
                        </td>
                        <td>{{line.quantity}}</td>
                        <td>{{line.price | currency:'EUR':'symbol':'1.2-2'}}</td>
                        <td>{{line.subtotal | currency:'EUR':'symbol':'1.2-2'}}</td>
                        <td>{{line.taxAmount | currency:'EUR':'symbol':'1.2-2'}}</td>
                        <td>{{(line.subtotal + line.taxAmount) | currency:'EUR':'symbol':'1.2-2'}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="8">No se han encontrado líneas</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>

    <div class="grid">
        <div class="col-4 input-field" *ngIf="payment.type=='partial'">
            <label for="price">Precio</label>
            <input [(ngModel)]="payment.price" pInputText type="number" (input)="calculatePrices()" [disabled]="type=='incoming_invoice'">
        </div>                
        <div class="col-4 input-field" *ngIf="payment.type=='partial'">
            <label for="code">Impuestos(%)</label>
            <p-dropdown [(ngModel)]="payment.taxPercent" [options]="taxes"
                optionLabel="displayName" optionValue="percent" appendTo="body" filterBy="name"
                placeholder="Seleccione opción" (onChange)="calculatePrices()"></p-dropdown>                            
            <label class="mt-2">
                {{ payment.taxAmount | currency:'EUR':'symbol':'1.2-2' }}
            </label>
        </div>
        <div class="col-4 input-field">
            <label for="total">Total</label>
            <input pInputText type="text" value="{{ payment.total | currency:'EUR':'symbol':'1.2-2' }}" disabled>
        </div>
        <div class="col-12 input-field">
            <label for="description">Notas</label>
            <textarea pInputTextarea [(ngModel)]="payment.notes" style="field-sizing: content;"
                rows="3"></textarea>
        </div>
    </div>
    <ng-template pTemplate="footer">        
        <button pButton label="Cancelar" icon="pi pi-times" class="p-button-secondary" (click)="displayPaymentModal=false"></button>
        <button pButton label="Guardar" icon="pi pi-check" (click)="savePayment()"></button>
    </ng-template>
</p-dialog>

<p-dialog header="Revisión de factura" [(visible)]="displayReviewModal" [modal]="true" [closable]="false"
    [style]="{width: '500px'}">
    <p-messages severity="info">
                <ng-template pTemplate>
                    <div>
                        La cantidad pagada por la compañía es {{ payment.companyPayedAmmount | currency:'EUR':'symbol':'1.2-2' }}, <b>{{ payment.total | currency:'EUR':'symbol':'1.2-2' }} {{(payment.total>0?'menos':'más')}}</b> de la cantidad prevista.
                    </div>
                </ng-template>
            </p-messages>
    <div class="grid">
        <div class="col-6 input-field">
            <label for="date">Fecha</label>
            <p-calendar [firstDayOfWeek]="1" id="date" [(ngModel)]="payment.date" [showIcon]="true" [showButtonBar]="true"
                [monthNavigator]="true" [yearNavigator]="true" dateFormat="dd/mm/yy"
                appendTo="body"></p-calendar>
        </div>
        <div class="col-6 input-field">
            <label for="code">Razón de revisión</label>
            <p-dropdown [(ngModel)]="payment.revisionReasonId" [options]="transactionRevisionReasons"
                optionLabel="name" optionValue="id" appendTo="body" filterBy="name"
                placeholder="Seleccione opción"></p-dropdown>                                        
        </div>

        <div class="col-12 input-field" *ngIf="payment.revisionReasonId === -1">
            <label for="description">Descripción</label>
            <textarea pInputTextarea [(ngModel)]="payment.notes" style="field-sizing: content;"
                rows="3"></textarea>
        </div>
        <div class="col-4 input-field">
            <label for="price">Precio</label>
            <input [(ngModel)]="payment.price" pInputText type="number" (input)="calculatePrices()">
        </div>                
        <div class="col-4 input-field">
            <label for="code">Impuestos(%)</label>
            <p-dropdown [(ngModel)]="payment.taxPercent" [options]="taxes"
                optionLabel="displayName" optionValue="percent" appendTo="body" filterBy="name"
                placeholder="Seleccione opción" (onChange)="calculatePrices()"></p-dropdown>                            
            <label class="mt-2">
                {{ payment.taxAmount | currency:'EUR':'symbol':'1.2-2' }}
            </label>
        </div>
        <div class="col-4 input-field">
            <label for="total">Total</label>
            <input pInputText type="text" value="{{ payment.total | currency:'EUR':'symbol':'1.2-2' }}" disabled>
        </div>
        
    </div>
    <ng-template pTemplate="footer">        
        <button pButton label="Cancelar" icon="pi pi-times" class="p-button-secondary" (click)="displayReviewModal=false"></button>
        <button pButton label="Guardar" icon="pi pi-check" (click)="saveReview()"></button>
    </ng-template>
</p-dialog>

<p-dialog header="Anticipo" [(visible)]="displayRequestModal" [modal]="true" [closable]="false"
    [style]="{width: '500px'}">
    <div class="grid">
        <div class="col-12 input-field">
            <label for="workerId">Operario</label>
            <p-dropdown [options]="workers" [(ngModel)]="request.thirdPartyId" showClear [filter]="true"
                filterBy="name" placeholder="Seleccione un operario" optionLabel="name" optionValue="id"
                appendTo="body"></p-dropdown>
        </div>
        <div class="col-6 input-field">
            <label for="date">Fecha</label>
            <p-calendar [firstDayOfWeek]="1" id="date" [(ngModel)]="request.date" [showIcon]="true" [showButtonBar]="true"
                [monthNavigator]="true" [yearNavigator]="true" dateFormat="dd/mm/yy"
                appendTo="body"></p-calendar>
        </div>        
        <div class="col-6 input-field">
            <label for="total">Importe</label>
            <input [(ngModel)]="request.total" pInputText type="number">
        </div>                                
        <div class="col-12 input-field">
            <label for="description">Notas</label>
            <textarea pInputTextarea [(ngModel)]="payment.description" style="field-sizing: content;"
                rows="3"></textarea>
        </div>
    </div>
    <ng-template pTemplate="footer">        
        <button pButton label="Cancelar" icon="pi pi-times" class="p-button-secondary" (click)="displayRequestModal=false"></button>
        <button pButton label="Guardar" icon="pi pi-check" (click)="saveWorkerInvoiceRequest()"></button>
    </ng-template>
</p-dialog>

<p-confirmDialog [style]="{width: '450px'}" [breakpoints]="{'575px': '90vw'}"></p-confirmDialog>